import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { BookMarked } from "lucide-react";
import { cn } from "@/lib/utils";
interface StoryCoverProps {
  coverUrl: string | null;
  title: string;
  fill?: boolean;
  className?: string;
  sizes?: string;
  priority?: boolean;
  fallbackSize?: "default" | "compact";
}

/**
 * Renders a story cover image or a gradient fallback with the story title.
 * Reusable across browse cards, story cards, and detail pages.
 */
export function StoryCover(t0) {
  const $ = _c(25);
  const {
    coverUrl,
    title,
    fill: t1,
    className: t2,
    sizes,
    priority: t3,
    fallbackSize: t4
  } = t0;
  const fill = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const priority = t3 === undefined ? false : t3;
  const fallbackSize = t4 === undefined ? "default" : t4;
  if (coverUrl) {
    let t5;
    if ($[0] !== fill || $[1] !== sizes) {
      t5 = fill ? {
        fill: true,
        sizes: sizes ?? "288px"
      } : {
        width: 288,
        height: 384
      };
      $[0] = fill;
      $[1] = sizes;
      $[2] = t5;
    } else {
      t5 = $[2];
    }
    const t6 = `Cover for ${title}`;
    let t7;
    if ($[3] !== className || $[4] !== coverUrl || $[5] !== priority || $[6] !== t5 || $[7] !== t6) {
      t7 = <Image {...t5} priority={priority} className={className} alt={t6} src={coverUrl} />;
      $[3] = className;
      $[4] = coverUrl;
      $[5] = priority;
      $[6] = t5;
      $[7] = t6;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    return t7;
  }
  const t5 = fallbackSize === "compact" ? "gap-1.5 p-2" : "gap-3 p-4";
  let t6;
  if ($[9] !== className || $[10] !== t5) {
    t6 = cn("absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-primary via-primary/80 to-accent/90 shadow-inner dark:from-primary/50 dark:via-primary/30 dark:to-accent/40", t5, className);
    $[9] = className;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = fallbackSize === "compact" ? "size-7" : "size-12";
  let t8;
  if ($[12] !== t7) {
    t8 = cn("text-white/95 drop-shadow-md", t7);
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <BookMarked className={t8} />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = fallbackSize === "compact" ? "px-0.5 text-[11px]" : "px-2 text-lg";
  let t11;
  if ($[16] !== t10) {
    t11 = cn("line-clamp-3 text-center font-heading font-bold leading-tight text-white drop-shadow-md", t10);
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== title) {
    t12 = <span className={t11}>{title}</span>;
    $[18] = t11;
    $[19] = title;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t6 || $[23] !== t9) {
    t13 = <div className={t6}>{t9}{t12}</div>;
    $[21] = t12;
    $[22] = t6;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}